import { render, staticRenderFns } from "./aufgabe-attachment-fvc-table.vue?vue&type=template&id=4a9d66fc"
import script from "./aufgabe-attachment-fvc-table.vue?vue&type=script&lang=js"
export * from "./aufgabe-attachment-fvc-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports